import React, { useState, createContext, useEffect } from "react";
import { ENV } from "./config";
import { initAxiosDefaultValues } from "./util/initAxiosDefaultValues";

const Context = createContext({} as ContextProps);

type ContextProps = {
    env: "DEV" | "PROD";
    setEnv: (arg: "DEV" | "PROD") => void;
};

const ContextProvider = ({ children }: { children: JSX.Element}) => {
    const [env, setEnv] = useState<"DEV" | "PROD">(ENV);

    useEffect(() => {
      initAxiosDefaultValues(env);
    }, [env]);

    return (
        <Context.Provider value={{ env, setEnv }}>
            {children}
        </Context.Provider>
    );
};

export { Context, ContextProvider };
